import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ArticleRounded from '@mui/icons-material/ArticleRounded';
import DarkModeRounded from '@mui/icons-material/DarkModeRounded';
import DashboardRounded from '@mui/icons-material/DashboardRounded';
import DescriptionRounded from '@mui/icons-material/DescriptionRounded';
import InventoryRounded from '@mui/icons-material/InventoryRounded';
import LightModeRounded from '@mui/icons-material/LightModeRounded';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Divider from '@mui/material/Divider';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import { MoovyAppLayout } from 'moovy-ui-core';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { ROUTES } from '../../app/routes.js';
import { useTheme } from '../../contexts/themeContext.js';
import { useAuth } from '../../hooks/useAuth.js';
import { useLocale } from '../../hooks/useLocale.js';
import moovyLogo from '../../resources/moovy-logo.svg';
const AdminLayout = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const { logout } = useAuth();
    const { locale, setLocale } = useLocale();
    const { currentTheme, setTheme } = useTheme();
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const navigationItems = [
        {
            key: 'dashboard',
            label: t('nav.dashboard'),
            icon: _jsx(DashboardRounded, {}),
            onClick: () => navigate(ROUTES.DASHBOARD),
            active: location.pathname === ROUTES.DASHBOARD,
        },
        {
            key: 'applications',
            label: t('nav.applications'),
            icon: _jsx(DescriptionRounded, {}),
            onClick: () => navigate(ROUTES.APPLICATIONS),
            active: location.pathname === ROUTES.APPLICATIONS,
        },
        {
            key: 'products',
            label: t('nav.products'),
            icon: _jsx(InventoryRounded, {}),
            onClick: () => navigate(ROUTES.PRODUCTS),
            active: location.pathname === ROUTES.PRODUCTS,
        },
        {
            key: 'contracts',
            label: t('nav.contracts'),
            icon: _jsx(ArticleRounded, {}),
            onClick: () => navigate(ROUTES.CONTRACTS),
            active: location.pathname === ROUTES.CONTRACTS,
        },
    ];
    return (_jsx(MoovyAppLayout, { logo: _jsxs(Box, { sx: {
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                cursor: 'pointer',
            }, children: [_jsx("img", { src: moovyLogo, alt: "Moovy", style: { height: 30 } }), _jsx(Typography, { variant: "h6", noWrap: true, sx: { fontWeight: 'bold' }, children: "MOOVY" })] }), onLogoClick: () => navigate(ROUTES.DASHBOARD), userMenuContent: [
            _jsx(MenuItem, { onClick: () => {
                    setLocale('fi');
                }, disabled: locale === 'fi', children: "Suomi" }, "fi"),
            _jsx(MenuItem, { onClick: () => {
                    setLocale('en');
                }, disabled: locale === 'en', children: "English" }, "en"),
            _jsx(Divider, {}, "divider-theme"),
            _jsx(MenuItem, { onClick: () => {
                    setTheme('b2b-light');
                }, disabled: currentTheme === 'b2b-light', children: _jsxs(Box, { sx: { display: 'flex', alignItems: 'center', gap: 1 }, children: [_jsx(LightModeRounded, { fontSize: "small" }), t('common.theme.light')] }) }, "theme-light"),
            _jsx(MenuItem, { onClick: () => {
                    setTheme('b2b-dark');
                }, disabled: currentTheme === 'b2b-dark', children: _jsxs(Box, { sx: { display: 'flex', alignItems: 'center', gap: 1 }, children: [_jsx(DarkModeRounded, { fontSize: "small" }), t('common.theme.dark')] }) }, "theme-dark"),
            _jsx(Divider, {}, "divider-logout"),
            _jsx(MenuItem, { onClick: () => {
                    logout();
                }, children: _jsxs(Box, { sx: { display: 'flex', alignItems: 'center', gap: 1 }, children: [_jsx(LogoutRoundedIcon, { fontSize: "small" }), t('common.logout')] }) }, "logout"),
        ], sidebarOpen: sidebarOpen, onSidebarToggle: () => setSidebarOpen(!sidebarOpen), navigationItems: navigationItems, children: _jsx(Container, { maxWidth: "xl", sx: { py: 3 }, children: _jsx(Outlet, {}) }) }));
};
export default AdminLayout;
